import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

import { useState } from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import { blue, red } from '@mui/material/colors';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

// core import
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate  } from 'react-router-dom';
import React, { useEffect } from 'react';

import {
  loginAsync,
  loginStatus,
  loginError,
  loggedInUser,
  setStatusIdle
} from './../../../features/user/userSlice';



// https://frontendshape.com/post/react-mui-5-login-page-example
const LoginPage = () =>  {
  // core
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // internal state
  const [loading, setLoading] = useState(false);
  const [open, setOpen] =  useState(false);

  // selector hooks
  const status = useSelector(loginStatus);
  const error = useSelector(loginError);

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const email = data.get("email");
    const password = data.get("password");
    const requestData = {email, password};
    dispatch(loginAsync(requestData));
  };

 

  const handleClose = () => {
    dispatch(setStatusIdle());
  };

  useEffect(() => {
    if(status == "succeeded"){
      navigate("/");
    }
  }, [status]); // Include history as a dependency


  useEffect(() => {
    console.log("this is use effect for initial render");
  }, []);
  

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{  
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <Typography component="h1" variant="h5" color={red[500]}>
          { status == 'error' ? error : ""}
        </Typography>
        
 
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
          />
          <FormControlLabel
            control={<Checkbox value="remember" color="primary" />}
            label="Remember me"
          />
          <Box sx={{ m: 1, position: 'relative' }}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={status != 'idle'}
            >
              Sign In
            </Button>
            { status != 'idle' && (
                <CircularProgress
                  size={24}
                  sx={{
                    color: blue[500],
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    marginTop: '-12px',
                    marginLeft: '-12px',
                  }}
                />
            )}
        </Box>






          <Grid container>
            <Grid item xs>
              <Link href="/forgot-password" variant="body2">
                Forgot password?
              </Link>
            </Grid>
            <Grid item>
              <Link href="/register" variant="body2">
                {"Don't have an account? Sign Up"}
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Dialog
        open={ status == "error" }
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Error"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            { error }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}
export default LoginPage;